import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CraneContent from "./CranePumpContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route path="/suppliers/crane/pumps" component={CraneContent} />
          <Route path="/suppliers/crane">
            <Redirect to="/suppliers/crane/pumps" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
